import httpManager from '../../util/common'
import newsTypeLists from '../../../static/json/news_labels.json'
import { timestampToDate, dealNewsTypeLists } from '../../util/util'
import Cookies from 'js-cookie'
import LimitMask from '../../common/components/mask.vue'


export default {
  data () {
    return {
      loading: false,
      newsType: 'A',
      exportConfig: {},
      newsList: [],
      follow_entity:false,
      page: {
        pagenum: 1,
        pagesize: 14,
        total: 0,
        pagerCount:3,
        perfect: true,
      },
      showMask: false
    }
  },
  computed: {
    news_type_options() {
      return [
        { label: this.$t('home.all_news'), value: 'A' },
        { label: this.$t('esg.environment'), value: 'E' },
        { label: this.$t('esg.social_responsibility'), value: 'S' },
        { label: this.$t('esg.governance'), value: 'G' }
      ]
    },
    locale () {
      return Cookies.get('locale') || 'zh'
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData () {
      this.loading = true
      this.newsList = []
      this.page.total = 0
      let params = new Map()
      const newdTypeStr = dealNewsTypeLists(this.newsType)
      params.set('news_type', newdTypeStr)
      params.set('pagenum', this.page.pagenum)
      params.set('pagesize', this.page.pagesize)
      params.set('follow_entity', this.follow_entity)
      httpManager('esg_news', params)
        .then(res => {
          const { data } = res.data
          if (Object.prototype.toString.call(data).substring(8, 14) === 'Object') {
            this.page.total = res.data.page.total
            this.loading = false
            return
          }
          data.forEach(item  => {
            item.time = timestampToDate(item.ctime, true)
            if (item.company_info) {
              item.company = ''
              item.company_info.forEach((ele, index) => {
                if (index !== item.company_info.length - 1) {
                  item.company += `${ele.full_name[0]}, `
                } else {
                  item.company += ele.full_name[0]
                }
              });
            }
            newsTypeLists[this.locale].forEach(el => {
              if (el.children) {
                el.children.forEach(val => {
                  if (val.value == item.class) {
                    item.color = el.color
                    item.tag = val.title
                  }
                })
              }
            });
          })
          this.newsList = data
          this.page.total = res.data.page.total
          this.loading = false
        })
        .catch(error => {
          if (this.$route.path === '/home' && error.response.status === 403) {
            this.showMask = true
          }
          console.log(error)
          this.loading = false
        })
    },
    cardClick (val) {
      const { href } = this.$router.resolve({
        name: 'newsDetail',
        query: {
          news_id: val
        }
      })
      window.open(href, '_blank')
    },
    onChange ({ currentPage }) {
      this.page.pagenum = currentPage
      this.getData()
    },
  },
  watch: {
    follow_entity(){
      this.page.pagenum = 1
      this.getData()
    },
    newsType(value) {
      this.page.pagenum = 1
      this.getData()
    }
  }
}



// WEBPACK FOOTER //
// ./src/home/js/entity_clout.js